var map = {
	"./Aboutshero.png": 44557,
	"./Arrow 2.png": 8850,
	"./BrandStory/2001.png": 83437,
	"./BrandStory/2002.png": 76406,
	"./BrandStory/2017.png": 73616,
	"./BrandStory/2023.png": 24725,
	"./BrandStory/2024.png": 56314,
	"./BrandStory/BrandStoryHeader.png": 9099,
	"./BrandStory/aegis.png": 22973,
	"./BrandStory/godbg.png": 24911,
	"./Card(0)-ch.png": 54578,
	"./Card(0)-en.png": 76098,
	"./Card(1)-ch.png": 17415,
	"./Card(1)-en.png": 42483,
	"./Card(2)-ch.png": 87576,
	"./Card(2)-en.png": 38136,
	"./Card(3)-ch.png": 8053,
	"./Card(3)-en.png": 76929,
	"./Card(4)-ch.png": 30670,
	"./Card(4)-en.png": 89134,
	"./FaqHeading.png": 65201,
	"./Icon1.png": 64323,
	"./Icon2.png": 27464,
	"./Icon3.png": 67409,
	"./Icon4.png": 14942,
	"./Icon5.png": 2631,
	"./QR (1).png": 75380,
	"./QR.png": 8098,
	"./Rectangle.png": 92356,
	"./Services/Bedroom1.png": 5373,
	"./Services/Bedroom2.png": 24166,
	"./Services/Bedroom3.png": 89359,
	"./Services/Bedroom4.png": 20336,
	"./Services/Bedroom5.png": 26585,
	"./Services/Bedroom6.png": 43650,
	"./Services/Garden1.png": 56822,
	"./Services/Garden2.png": 70797,
	"./Services/Livingroom1.png": 25169,
	"./Services/Livingroom2.png": 95002,
	"./Services/Livingroom3.png": 12579,
	"./Services/duigou.png": 53697,
	"./Services/home-title.png": 1756,
	"./Services/jianhu1.png": 48886,
	"./Services/jianhu2.png": 79213,
	"./Services/jianhu3.png": 8964,
	"./Services/jianhu4.png": 89179,
	"./Services/local.png": 83715,
	"./Testimonials/Frame1.png": 95480,
	"./Testimonials/Frame10.png": 47082,
	"./Testimonials/Frame11.png": 2291,
	"./Testimonials/Frame12.png": 56536,
	"./Testimonials/Frame13.png": 77665,
	"./Testimonials/Frame14.png": 59950,
	"./Testimonials/Frame15.png": 89175,
	"./Testimonials/Frame2.png": 69971,
	"./Testimonials/Frame3.png": 19210,
	"./Testimonials/Frame4.png": 3877,
	"./Testimonials/Frame5.png": 70012,
	"./Testimonials/Frame6.png": 75095,
	"./Testimonials/Frame7.png": 85102,
	"./Testimonials/Frame8.png": 17017,
	"./Testimonials/Frame9.png": 84912,
	"./Testimonials/touxiang.png": 30495,
	"./Testimonials/yinhao.png": 59176,
	"./Whoweare-ch.png": 90761,
	"./Whoweare-en.png": 68709,
	"./banner.png": 22313,
	"./banner1.png": 17892,
	"./banner2.png": 54751,
	"./banner3.png": 41462,
	"./banner4.png": 81545,
	"./banner5.png": 3424,
	"./banner6.png": 81755,
	"./blog/blog1.png": 18167,
	"./blog/blog2.png": 29436,
	"./blog/blog3.png": 46949,
	"./blog/blog4.png": 62282,
	"./blog/blog5.png": 13043,
	"./blog/detail-1-1.png": 49407,
	"./blog/detail-1-2.png": 94756,
	"./blog/detail-1-3.png": 34701,
	"./blog/detail-1-4.png": 78546,
	"./blog/detail-1-5.png": 76411,
	"./blog/detail-2-1.png": 23500,
	"./blog/detail-2-2.png": 59911,
	"./blog/detail-2-3.png": 41598,
	"./blog/detail-2-4.png": 82609,
	"./blog/detail-3-1.png": 47209,
	"./blog/detail-3-2.png": 56498,
	"./blog/detail-3-3.png": 70715,
	"./blog/detail-3-4.png": 89060,
	"./blog/detail-4-1.png": 63390,
	"./blog/detail-4-12.png": 28110,
	"./blog/detail-4-2.png": 49141,
	"./blog/detail-4-3.png": 66252,
	"./blog/detail-4-4.png": 96419,
	"./blog/detail-4-5.png": 74842,
	"./blog/detail-4-6.png": 99505,
	"./blog/detail-5-1.png": 82003,
	"./blog/detail-5-2.png": 86392,
	"./blog/detail-5-3.png": 7521,
	"./blog1.png": 98374,
	"./blog2.png": 95933,
	"./blog3.png": 58452,
	"./blog5.png": 34210,
	"./chinese.png": 73570,
	"./close.png": 86415,
	"./custom1.png": 91673,
	"./custom123.png": 89476,
	"./custom2.png": 77666,
	"./custom3.png": 41323,
	"./detail-3-1.png": 52634,
	"./down.png": 80007,
	"./english.png": 12451,
	"./logo.png": 82806,
	"./school/School(0).png": 81671,
	"./school/School(1).png": 61312,
	"./school/School(10).png": 36116,
	"./school/School(11).png": 56955,
	"./school/School(12).png": 18154,
	"./school/School(13).png": 17233,
	"./school/School(14).png": 55584,
	"./school/School(15).png": 75943,
	"./school/School(16).png": 43286,
	"./school/School(17).png": 25149,
	"./school/School(18).png": 93644,
	"./school/School(19).png": 88051,
	"./school/School(2).png": 30877,
	"./school/School(20).png": 46487,
	"./school/School(21).png": 58896,
	"./school/School(22).png": 52717,
	"./school/School(23).png": 84102,
	"./school/School(24).png": 12715,
	"./school/School(25).png": 58436,
	"./school/School(26).png": 20545,
	"./school/School(27).png": 99162,
	"./school/School(28).png": 37583,
	"./school/School(29).png": 21000,
	"./school/School(3).png": 65366,
	"./school/School(30).png": 43894,
	"./school/School(31).png": 61213,
	"./school/School(4).png": 62683,
	"./school/School(5).png": 41844,
	"./school/School(6).png": 22961,
	"./school/School(7).png": 23882,
	"./school/School(8).png": 29631,
	"./school/School(9).png": 57048,
	"./schoolicon1.png": 80975,
	"./schoolicon2.png": 58516,
	"./schoolicon3.png": 79645,
	"./up.png": 11788,
	"./whiteLogo.png": 42053,
	"./xiahuaxian-ch.png": 8891,
	"./xiahuaxian-en.png": 47367,
	"./xixinguanzhao-bg.png": 69604,
	"./xixinguanzhao-ch.png": 69048,
	"./xixinguanzhao-en.png": 26936,
	"./xixinshouhu-ch.png": 79229,
	"./xixinshouhu-en.png": 81449,
	"./yellow.png": 82107,
	"./yinhaoleft.png": 53404,
	"./yinhaoright.png": 71961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;